import {StandardWriteAction} from 'app/services/standard-write-action';
import {PwaModeService} from 'app/services/pwa-mode.service';
import {isStandardsPhone} from 'app/content-page/my-standards/standards-viewport';
import {STANDARD_READ_QUERY, STANDARD_READ_RUSSIAN, STANDARD_READ_ENGLISH, standardReaderDocument} from 'app/content-page/my-standards/standard-reader-document';
import {Standard} from 'app/models/standard.model';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/concatMap';
import {StandardFileActions} from 'app/services/standard-file-actions';
import {StandardFiles, STANDARD_FILE_METADATA} from 'app/models/standard-files.model';
import {standardResponseWithVersion} from 'app/services/standard-version';
import {clearStandardViewPageOnLeave} from 'app/services/standard-list-navigation';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import { Component, Injector, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AdminService } from '../../../services/admin.service';
import { UserService } from '../../../services/user.service';
import { ConfirmationPopupComponent } from '../view-group/popups/confirmation-popup/confirmation-popup.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Blank } from '../../../models/blank.model';
import { Question } from '../../../models/question.model';
import { NewBlank } from '../../../models/new-blank.model';
import { AddNewQuestionsComponent } from './popups/add-new-questions/add-new-questions.component';
import { EditStandardInfoComponent } from './popups/edit-standard-info/edit-standard-info.component';
import { FullUser } from '../../../models/full-user.model';
import { Status } from '../../../models/status.model';
import { Group } from '../../../models/group.model';
import { ApiConnectService } from '../../../services/api-connect.service';
import { StandardDocumentContext, storeDocumentContext, ViewDocxService } from '../../../services/view-docx.service';
import { ViewDocxComponent } from '../view-docx/view-docx.component';
import { StepsControllerService } from "../../../services/steps-controller.service";
import { EditQuestionComponent } from '../../admin/create-operating-standard/opst-step-eight/edit-question-step-popup/edit-question.component';
import {
  StandardAiQuestionGenerationStatus,
  StandardAiQuestionLanguage
} from '../../../models/standard-ai-question-generation.model';
import { TranslateService } from '@ngx-translate/core';

const AI_LANGUAGE_RUSSIAN: StandardAiQuestionLanguage = 'RUSSIAN';
const AI_STATUS_KEY_PREFIX = 'STANDARD_AI_QUESTIONS_STATUS_';
const AI_FORCE_CONFIRM_KEY = 'STANDARD_AI_QUESTIONS_CONFIRM_FORCE';
const AI_STATUS_MANUAL_OVERRIDE = 'MANUAL_OVERRIDE';
const AI_MANAGEMENT_ROLES = ['ROLE_HEAD', 'ROLE_ADMIN'];
const MISSING_ROLE_INDEX = -1;
const STANDARD_ROUTE_ID = 'id';
const STANDARD_RESPONSE_OK = 200;
const QUESTION_LANGUAGE_RUSSIAN = 'RUSSIAN';
const QUESTION_REMOVE_CONFIRM = 'DYWTDTQ';
const FIRST_QUESTION_INDEX = 0;
const REMOVED_QUESTION_COUNT = 1;
const CONFIRM_ACCEPTED = 'ok';
const CONFIRM_CANCELLED = 'cancel';
const BLANK_REMOVED_MESSAGE_PREFIX = 'Blank ';
const BLANK_REMOVED_MESSAGE_SUFFIX = ' deleted successfully';
const EDITING_STANDARD_STATUS = 'ON_EDITING';
const READER_MODAL_OPTIONS = {size: 'lg' as 'lg', backdrop: 'static' as 'static'};

@Component({
  selector: 'app-view-standard',
  templateUrl: './view-standard.component.html',
  styleUrls: ['./view-standard.component.css']
})

export class ViewStandardComponent implements OnInit, OnDestroy {
  isPhone = isStandardsPhone();
  canAuthor = false;
  authoringAccessFailed = false;
  openingEditor = false;
  editFailed = false;
  readerMaterialFailed = false;
  private readerIntentHandled = false;
  private phoneRouteId: string;
  private readerModal: NgbModalRef;
  get showReaderMaterialError(): boolean { return isStandardsPhone() && this.readerMaterialFailed; }
  private editorTransition = false;
  writeAction = new StandardWriteAction();
  private editorModal: NgbModalRef;
  private viewDestroyed = false;
  fileActions: StandardFileActions;
  fileReloadFailed = false;
  fileReloadPending = false;
  private filesDestroyed$ = new Subject<void>();
  private standardChanged$ = new Subject<void>();

  standard: any;
  newBlanks: NewBlank[] = [];
  users: any;
  divisions: any;
  selectedUser: FullUser;
  selectedDivision: Group;

  selectedStatus: Status;

  isUploadDisabled = false;

  isNewStatus = false;
  isNewInitiator = false;
  isNewDivision = false;

  // RUS
  isNewRuDoc = false;
  isNewRuPpt = false;
  isNewRuPdf = false;
  fileRuDoc: File = null;
  fileRuPpt: File = null;
  fileRuPdf: File = null;
  // ENG
  isNewEnDoc = false;
  isNewEnPpt = false;
  isNewEnPdf = false;
  fileEnDoc: File = null;
  fileEnPpt: File = null;
  fileEnPdf: File = null;

  public isLoaded = false;
  public errorInfo = false;
  errorMessage = false;

  public isDeleted: boolean;
  deleteMessage: string;
  aiQuestionStatusByLanguage: { [language: string]: StandardAiQuestionGenerationStatus } = {};
  aiQuestionLoadingByLanguage: { [language: string]: boolean } = {};
  aiQuestionStatusLoadingByLanguage: { [language: string]: boolean } = {};
  aiQuestionStatusErrorByLanguage: { [language: string]: boolean } = {};
  aiQuestionGenerationErrorByLanguage: { [language: string]: boolean } = {};
  aiQuestionStatusVisibleByLanguage: { [language: string]: boolean } = {};
  private aiQuestionStatusHideTimers: { [language: string]: any } = {};


  private route: ActivatedRoute;
  private adminService: AdminService;
  public userService: UserService;
  public viewDocxService: ViewDocxService;
  private modalService: NgbModal;
  private apiConnectService: ApiConnectService;
  public stepsControllerService: StepsControllerService;
  private translate: TranslateService;
  private pwaMode: PwaModeService;

  constructor(injector: Injector) {
    this.route = injector.get(ActivatedRoute);
    this.adminService = injector.get(AdminService);
    this.userService = injector.get(UserService);
    this.viewDocxService = injector.get(ViewDocxService);
    this.modalService = injector.get(NgbModal);
    this.apiConnectService = injector.get(ApiConnectService);
    this.stepsControllerService = injector.get(StepsControllerService);
    this.translate = injector.get(TranslateService);
    this.pwaMode = injector.get(PwaModeService);
    this.fileActions = new StandardFileActions(this.adminService, this.modalService);
  }

  ngOnInit(): void {
    if (this.isPhone && this.route.params) {
      this.route.params.takeUntil(this.filesDestroyed$).subscribe(params => this.loadPhoneStandard(params[STANDARD_ROUTE_ID]));
      return;
    }
    this.loadStandard();
  }

  private loadPhoneStandard(id: string): void {
    if (id === this.phoneRouteId) { return; }
    this.phoneRouteId = id;
    this.readerIntentHandled = false;
    this.readerMaterialFailed = false;
    this.standardChanged$.next();
    this.fileReloadPending = false;
    this.closeReaderDocument();
    this.loadStandard();
  }

  private loadEditorChoices(): void {
    this.adminService.getAllFullUsers().takeUntil(this.filesDestroyed$).takeUntil(this.standardChanged$).subscribe(
      (response: HttpResponse<FullUser[]>) => {
        this.errorMessage = false;
        if (response.status === STANDARD_RESPONSE_OK) {
          this.users = response.body;
        }
      },
      () => {
        this.errorMessage = true;
      });

    // Divisions
    this.adminService.getAllGroups().takeUntil(this.filesDestroyed$).takeUntil(this.standardChanged$).subscribe(
      (response: HttpResponse<Group[]>) => {
        this.divisions = response.body;
      },
      () => {
      }
    );

  }

  loadStandard(): void {
    if (this.openingEditor || this.fileActions.pending || this.fileReloadPending || this.writeAction.pending || this.editorModal) { return; }
    this.standardChanged$.next();
    this.fileReloadPending = true;
    this.fileReloadFailed = false;
    this.canAuthor = false;
    this.authoringAccessFailed = false;
    this.editFailed = false;
    this.adminService.getStandard(this.route.snapshot.params[STANDARD_ROUTE_ID])
      .takeUntil(this.filesDestroyed$).takeUntil(this.standardChanged$).subscribe(
      (response: HttpResponse<StandardFiles>) => this.acceptLoadedStandard(response),
      () => this.rejectStandardLoad()
    );
  }

  private acceptLoadedStandard(response: HttpResponse<StandardFiles>): void {
    if (response.status !== STANDARD_RESPONSE_OK || !response.body) { this.rejectStandardLoad(); return; }
    if (this.isPhone && response.body.id !== this.route.snapshot.params[STANDARD_ROUTE_ID]) { this.rejectStandardLoad(); return; }
    this.standard = standardResponseWithVersion(response).body;
    this.stepsControllerService.currentStandard = this.standard;
    this.isLoaded = true;
    this.fileReloadPending = this.errorMessage = this.errorInfo = false;
    this.selectedUser = this.standard.author;
    this.selectedDivision = this.standard.bindingGroup || null;
    this.selectedStatus = this.standard.status;
    this.resetFileDraft();
    this.fileActions.reset();
    this.writeAction.reset();
    this.loadAuthoringAccess();
    this.openRequestedDocument();
  }

  private openRequestedDocument(): void {
    if (this.readerIntentHandled || !isStandardsPhone() || this.viewDestroyed) { return; }
    const query = this.route.snapshot.queryParams;
    if (!query || (query[STANDARD_READ_QUERY] !== STANDARD_READ_RUSSIAN && query[STANDARD_READ_QUERY] !== STANDARD_READ_ENGLISH)) { return; }
    this.readerIntentHandled = true;
    const context = standardReaderDocument(this.standard, query[STANDARD_READ_QUERY]);
    if (!context) { this.readerMaterialFailed = true; return; }
    this.openPublishedDocument(context);
  }

  retryReaderDocument(): void {
    if (!isStandardsPhone() || this.readerModal) { return; }
    this.readerMaterialFailed = false;
    this.readerIntentHandled = false;
    this.loadStandard();
  }

  private openPublishedDocument(context: StandardDocumentContext): void {
    storeDocumentContext(context);
    try { this.readerModal = this.modalService.open(ViewDocxComponent, READER_MODAL_OPTIONS); }
    catch (error) {
      this.readerMaterialFailed = true;
      storeDocumentContext({fileId: null, standardId: null, fileLink: null});
      return;
    }
    const openedModal = this.readerModal;
    const cleanup = () => {
      if (this.readerModal !== openedModal) { return; }
      this.readerModal = null;
      storeDocumentContext({fileId: null, standardId: null, fileLink: null});
    };
    this.readerModal.result.then(cleanup, cleanup);
  }

  private closeReaderDocument(): void {
    if (!this.readerModal) { return; }
    const modal = this.readerModal;
    this.readerModal = null;
    storeDocumentContext({fileId: null, standardId: null, fileLink: null});
    modal.dismiss();
  }

  private rejectStandardLoad(): void {
    this.isLoaded = true;
    this.fileReloadPending = false;
    this.fileReloadFailed = this.errorInfo = true;
  }

  private resetFileDraft(): void {
    this.newBlanks = [];
    this.isNewStatus = this.isNewInitiator = this.isNewDivision = false;
    Object.keys(STANDARD_FILE_METADATA).forEach(type => {
      const fields = STANDARD_FILE_METADATA[type];
      this[fields.draft] = null;
      this[fields.selected] = false;
    });
  }

  ngOnDestroy(): void {
    this.viewDestroyed = true;
    this.closeReaderDocument();
    if (this.editorModal) { this.editorModal.dismiss(); }
    this.writeAction.ngOnDestroy();
    this.fileActions.ngOnDestroy();
    this.filesDestroyed$.next();
    this.filesDestroyed$.complete();
    this.standardChanged$.next();
    this.standardChanged$.complete();
    this.clearAiQuestionStatusTimers();
    clearStandardViewPageOnLeave();
    if (!this.editorTransition) { this.stepsControllerService.leaveComponent(); }
  }

  // Check if field has text
  hasText(text) {
    if (text !== null) {
      return text.trim().length > 0;
    } else {
      return false;
    }
  }

  selectStatus(status) {
    this.selectedStatus = status;
    if (status !== this.standard.status) {
      this.isNewStatus = true;
    } else {

      this.isNewStatus = false;
    }
  }

  selectUser(user: FullUser) {
    this.selectedUser = user;
    if (user.id !== this.standard.author.id) {
      this.isNewInitiator = true;
    } else {
      this.isNewInitiator = false;
    }
  }

  selectDivision(divis: Group) {
    this.selectedDivision = divis;
    if (this.standard.bindingGroup !== null) {
      if (divis.id !== this.standard.bindingGroup.id) {
        this.isNewDivision = true;
      } else {
        this.isNewDivision = false;
      }
    } else {
      this.isNewDivision = true;
    }
  }

  saveInitiator(): void {
    if (this.writesBlocked) { return; }
    const selection = this.selectedUser;
    this.writeAction.run(this.standard as Standard, snapshot => this.adminService.changeInitiator(snapshot, selection), () => {
      this.standard.author = selection;
      this.isNewInitiator = false;
      this.errorMessage = false;
    });
  }

  saveDivision(): void {
    if (this.writesBlocked) { return; }
    const selection = this.selectedDivision;
    this.writeAction.run(this.standard as Standard, snapshot => this.adminService.changeDivision(snapshot, selection), () => {
      this.standard.bindingGroup = selection;
      this.isNewDivision = false;
      this.errorMessage = false;
    });
  }

  saveStatus(): void {
    if (this.writesBlocked) { return; }
    const selection = this.selectedStatus;
    this.writeAction.run(this.standard as Standard, snapshot => this.adminService.changeStatus(snapshot, selection), () => {
      this.standard.status = selection;
      this.isNewStatus = false;
      this.errorMessage = false;
    });
  }

  openEditInfoModal() {
    if (this.writesBlocked) { return; }
    const modalRef = this.modalService.open(EditStandardInfoComponent);
    modalRef.componentInstance.setStandard(this.standard);
    this.watchStandardModal(modalRef);
  }

  openNewQuestionsModal() {
    if (this.writesBlocked) { return; }
    const modalRef = this.modalService.open(AddNewQuestionsComponent);
    modalRef.componentInstance.setStandard(this.standard);
    this.watchStandardModal(modalRef);
  }

  get writesBlocked(): boolean {
    return !this.canAuthor || this.fileActions.pending || this.fileActions.requiresReload || this.fileReloadPending ||
      this.writeAction.pending || this.writeAction.requiresReload || !!this.editorModal;
  }

  editStandard(): void {
    if (!this.canAuthor || !this.standard || this.openingEditor || this.fileReloadPending) { return; }
    this.openingEditor = true;
    this.editFailed = false;
    const standardId = this.standard.id;
    this.adminService.getTempStandard(standardId).takeUntil(this.filesDestroyed$).takeUntil(this.standardChanged$).subscribe(
      response => this.openStandardEditor(standardId, response),
      () => { this.openingEditor = false; this.editFailed = true; }
    );
  }

  private openStandardEditor(standardId: string, response: HttpResponse<Object>): void {
    if (response.status !== STANDARD_RESPONSE_OK || !response.body) {
      this.openingEditor = false;
      this.editFailed = true;
      return;
    }
    const draft = Object.assign({}, response.body, { status: EDITING_STANDARD_STATUS });
    this.editorTransition = true;
    this.stepsControllerService.setEditActive(true);
    this.stepsControllerService.setEditActiveWithNotification(false);
    this.stepsControllerService.setTempParrentID(standardId);
    this.stepsControllerService.setCurrentStandard(draft);
  }

  private watchStandardModal(modal: NgbModalRef): void {
    this.editorModal = modal;
    const editor = modal.componentInstance;
    modal.result.then(() => this.finishStandardModal(editor.didReload), () => this.finishStandardModal(editor.didReload));
  }

  private finishStandardModal(didReload: boolean): void {
    this.editorModal = null;
    if (this.viewDestroyed || !didReload) { return; }
    this.acceptLoadedStandard(new HttpResponse<StandardFiles>({body: this.standard, status: STANDARD_RESPONSE_OK}));
  }

  addNewBlank() {
    this.newBlanks.push(new NewBlank(null, null, null));
  }

  saveBlank(index: number): void {
    const draft = this.newBlanks[index];
    if (this.writesBlocked || !draft || !draft.formData) { return; }
    this.fileActions.uploadBlanks(this.standard, [draft], () => {
      this.newBlanks = this.newBlanks.filter(item => item !== draft);
      this.errorMessage = false;
    });
  }

  blanksChange(event, index: number) {
    const fileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      const formData = new FormData();
      formData.append('file', file, file.name);
      this.newBlanks[index].formData = formData;
    }
  }

  deleteBlank(key) {

    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DYWTDTB';
    modalRef.result.then((result) => {
      if (result === 'ok') {
        // Delete;
        if (key > -1) {
          this.newBlanks.splice(key, 1);
        }
      }
    });
  }

  downloadFile(id) {
    this.isLoaded = false;
    this.userService.getFile(id).subscribe(
      (response: any) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.body);
        link.download = response.headers.get('filename');
        link.click();
        link.remove();
      },
      () => {
      }, () => {
        this.isLoaded = true;
      }
    );
  }


  fileChange(typeFile, event) {
    if (typeFile === 'RU_PPT') {
      if (event.target.files.length > 0) {
        this.fileRuPpt = event.target.files[0];
        this.isNewRuPpt = true;
      } else {
        this.fileRuPpt = null;
        this.isNewRuPpt = false;
      }
    }

    if (typeFile === 'RU_DOC') {
      if (event.target.files.length > 0) {
        this.fileRuDoc = event.target.files[0];
        this.isNewRuDoc = true;
      } else {
        this.fileRuDoc = null;
        this.isNewRuDoc = false;
      }
    }

    if (typeFile === 'RU_PDF') {
      if (event.target.files.length > 0) {
        this.fileRuPdf = event.target.files[0];
        this.isNewRuPdf = true;
      } else {
        this.fileRuPdf = null;
        this.isNewRuPdf = false;
      }
    }

    if (typeFile === 'EN_PPT') {
      if (event.target.files.length > 0) {
        this.fileEnPpt = event.target.files[0];
        this.isNewEnPpt = true;
      } else {
        this.fileEnPpt = null;
        this.isNewEnPpt = false;
      }
    }
    if (typeFile === 'EN_DOC') {
      if (event.target.files.length > 0) {
        this.fileEnDoc = event.target.files[0];
        this.isNewEnDoc = true;
      } else {
        this.fileEnDoc = null;
        this.isNewEnDoc = false;
      }
    }
    if (typeFile === 'EN_PDF') {
      if (event.target.files.length > 0) {
        this.fileEnPdf = event.target.files[0];
        this.isNewEnPdf = true;
      } else {
        this.fileEnPdf = null;
        this.isNewEnPdf = false;
      }
    }

  }

  openDocModalDOCX(fileLink) {

    localStorage.setItem('fileLink', fileLink);

    const modalRef = this.modalService.open(ViewDocxComponent, { size: 'lg', backdrop: 'static' });
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxIDManually();
      }
    }, () => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxIDManually();
    });

  }

  openDocModal(docxID, sID) {

    localStorage.setItem('DocxID', docxID);
    localStorage.setItem('DocxSID', sID);

    const modalRef = this.modalService.open(ViewDocxComponent, { size: 'lg', backdrop: 'static' });
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxID();
      }
    }, () => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxID();
    });

  }

  deleteFileDOCX(fileLink: string, type: string, fileId: string): void {
    if (this.writesBlocked) { return; }
    this.fileActions.remove(this.standard, {type: type, fileId: fileId, link: fileLink}, () => this.acceptFileRemoval());
  }


  uploadFile(type: string): void {
    if (this.writesBlocked) { return; }
    const fields = STANDARD_FILE_METADATA[type];
    if (!fields) { return; }
    this.fileActions.upload(this.standard, {type: type, file: this[fields.draft]}, () => this.acceptFileUpload(type));
  }

  private acceptFileUpload(type: string): void {
    const fields = STANDARD_FILE_METADATA[type];
    this[fields.draft] = null;
    this[fields.selected] = false;
    this.errorMessage = false;
  }

  openPdfStnd(fileId: string) {
    window.open(this.apiConnectService.getPdf + fileId, '_blank');
  }

  deleteFile(fileId: string, type: string): void {
    if (this.writesBlocked) { return; }
    this.fileActions.remove(this.standard, {type: type, fileId: fileId}, () => this.acceptFileRemoval());
  }

  private acceptFileRemoval(): void {
    this.errorMessage = false;
  }

  deleteBlankFile(blank: Blank): void {
    if (this.writesBlocked) { return; }
    this.fileActions.removeBlank(this.standard, blank, () => {
      this.errorMessage = false;
      this.isDeleted = true;
      this.deleteMessage = BLANK_REMOVED_MESSAGE_PREFIX + blank.name + BLANK_REMOVED_MESSAGE_SUFFIX;
    });
  }

  get isRussianAiQuestionLoading(): boolean {
    return this.isAiQuestionLoading(AI_LANGUAGE_RUSSIAN);
  }

  get russianAiQuestionStatusKey(): string {
    return this.getAiQuestionStatusKey(AI_LANGUAGE_RUSSIAN);
  }

  get russianGenerateAiQuestionButtonKey(): string {
    return this.getGenerateAiQuestionButtonKey(AI_LANGUAGE_RUSSIAN);
  }

  get isRussianAiQuestionStatusVisible(): boolean {
    return this.isAiQuestionLoading(AI_LANGUAGE_RUSSIAN)
      || this.aiQuestionStatusVisibleByLanguage[AI_LANGUAGE_RUSSIAN] === true;
  }

  loadAiQuestionStatus(language: StandardAiQuestionLanguage): void {
    if (!this.standard || !this.standard.id || !this.canAuthor) { return; }
    const requestedStandardId = this.standard.id;
    this.aiQuestionStatusLoadingByLanguage[language] = true;
    this.aiQuestionStatusErrorByLanguage[language] = false;
    this.adminService.getStandardAiQuestionStatus(requestedStandardId, language)
      .takeUntil(this.filesDestroyed$).takeUntil(this.standardChanged$)
      .subscribe((response: HttpResponse<StandardAiQuestionGenerationStatus>) => {
      this.aiQuestionStatusLoadingByLanguage[language] = false;
      if (response && this.standard && this.standard.id === requestedStandardId) {
        this.aiQuestionStatusByLanguage[language] = response.body;
      }
    }, () => {
      this.aiQuestionStatusLoadingByLanguage[language] = false;
      if (this.standard && this.standard.id === requestedStandardId) { this.aiQuestionStatusErrorByLanguage[language] = true; }
    });
  }

  loadAuthoringAccess(): void {
    if (this.pwaMode.isEnabled || (this.isPhone && !this.hasAiManagementRole)) {
      this.canAuthor = false;
      this.authoringAccessFailed = false;
      return;
    }
    if (!this.standard || !this.standard.id) { return; }
    const standardId = this.standard.id;
    this.adminService.getStandardAuthoringAccess(standardId)
      .takeUntil(this.filesDestroyed$).takeUntil(this.standardChanged$).subscribe(access => {
      if (!this.standard || this.standard.id !== standardId) { return; }
      this.canAuthor = access.body === true;
      this.authoringAccessFailed = false;
    }, () => {
      if (this.standard && this.standard.id === standardId) {
        this.canAuthor = false;
        this.authoringAccessFailed = true;
      }
    });
  }

  get hasAiManagementRole(): boolean {
    const user = this.userService.getLocal();
    return !!user && !!user.roles && AI_MANAGEMENT_ROLES.some(role => user.roles.indexOf(role) !== MISSING_ROLE_INDEX);
  }

  onGenerateRussianAiQuestions(): void {
    if (this.writesBlocked) { return; }
    if (this.canForceGenerateAiQuestions(AI_LANGUAGE_RUSSIAN)) {
      this.forceGenerateAiQuestions(AI_LANGUAGE_RUSSIAN);
      return;
    }
    this.generateAiQuestions(AI_LANGUAGE_RUSSIAN);
  }

  private generateAiQuestions(language: StandardAiQuestionLanguage): void {
    this.requestAiQuestionGeneration(language, this.adminService.generateStandardAiQuestions, true);
  }

  private forceGenerateAiQuestions(language: StandardAiQuestionLanguage): void {
    if (!window.confirm(this.translate.instant(AI_FORCE_CONFIRM_KEY))) {
      return;
    }
    this.requestAiQuestionGeneration(language, this.adminService.forceGenerateStandardAiQuestions, false);
  }

  private requestAiQuestionGeneration(
    language: StandardAiQuestionLanguage,
    requestFactory: (standardId: string, language: string) => Observable<HttpResponse<StandardAiQuestionGenerationStatus>>,
    retryWithForceOnManualOverride: boolean
  ): void {
    if (!this.standard || !this.standard.id) {
      return;
    }
    const requestedStandardId = this.standard.id;
    this.aiQuestionLoadingByLanguage[language] = true;
    this.aiQuestionGenerationErrorByLanguage[language] = false;
    this.aiQuestionStatusVisibleByLanguage[language] = true;
    requestFactory.call(this.adminService, requestedStandardId, language)
      .subscribe((response: HttpResponse<StandardAiQuestionGenerationStatus>) => {
      if (!this.standard || this.standard.id !== requestedStandardId) {
        this.aiQuestionLoadingByLanguage[language] = false;
        return;
      }
      this.aiQuestionStatusByLanguage[language] = response.body;
      if (retryWithForceOnManualOverride && this.isManualOverrideResponse(response.body)) {
        this.aiQuestionLoadingByLanguage[language] = false;
        this.showAiQuestionStatusTemporarily(language);
        this.forceGenerateAiQuestions(language);
        return;
      }
      this.loadStandard();
      this.aiQuestionLoadingByLanguage[language] = false;
      this.showAiQuestionStatusTemporarily(language);
    }, () => {
      this.aiQuestionLoadingByLanguage[language] = false;
      this.aiQuestionGenerationErrorByLanguage[language] = true;
      this.showAiQuestionStatusTemporarily(language);
    });
  }

  private showAiQuestionStatusTemporarily(language: StandardAiQuestionLanguage): void {
    this.aiQuestionStatusVisibleByLanguage[language] = true;
    if (this.aiQuestionStatusHideTimers[language]) {
      clearTimeout(this.aiQuestionStatusHideTimers[language]);
    }
    this.aiQuestionStatusHideTimers[language] = setTimeout(() => {
      this.aiQuestionStatusVisibleByLanguage[language] = false;
      this.aiQuestionStatusHideTimers[language] = null;
    }, 4000);
  }

  private clearAiQuestionStatusTimers(): void {
    Object.keys(this.aiQuestionStatusHideTimers).forEach((language) => {
      if (this.aiQuestionStatusHideTimers[language]) {
        clearTimeout(this.aiQuestionStatusHideTimers[language]);
      }
    });
    this.aiQuestionStatusHideTimers = {};
  }

  private isAiQuestionLoading(language: StandardAiQuestionLanguage): boolean {
    return this.aiQuestionLoadingByLanguage[language] === true;
  }

  private canForceGenerateAiQuestions(language: StandardAiQuestionLanguage): boolean {
    const status = this.aiQuestionStatusByLanguage[language];
    return this.isManualOverrideResponse(status);
  }

  private getAiQuestionStatusKey(language: StandardAiQuestionLanguage): string {
    if (this.aiQuestionLoadingByLanguage[language]) {
      return 'STANDARD_AI_QUESTIONS_GENERATING';
    }
    if (this.aiQuestionGenerationErrorByLanguage[language]) {
      return 'STANDARD_AI_QUESTIONS_GENERATE_ERROR';
    }
    if (this.aiQuestionStatusLoadingByLanguage[language]) {
      return 'STANDARD_AI_QUESTIONS_STATUS_LOADING';
    }
    if (this.aiQuestionStatusErrorByLanguage[language]) {
      return 'STANDARD_AI_QUESTIONS_STATUS_UNAVAILABLE';
    }
    const status = this.aiQuestionStatusByLanguage[language];
    return status ? AI_STATUS_KEY_PREFIX + status.status : 'STANDARD_AI_QUESTIONS_STATUS_EMPTY';
  }

  private getGenerateAiQuestionButtonKey(language: StandardAiQuestionLanguage): string {
    if (this.isAiQuestionLoading(language)) {
      return 'STANDARD_AI_QUESTIONS_GENERATING';
    }
    if (this.canForceGenerateAiQuestions(language)) {
      return 'STANDARD_AI_QUESTIONS_OVERWRITE';
    }
    return 'STANDARD_AI_QUESTIONS_GENERATE';
  }

  private isManualOverrideResponse(status: StandardAiQuestionGenerationStatus): boolean {
    return status && status.status === AI_STATUS_MANUAL_OVERRIDE;
  }

  openEditQuestionModal(question: Question, lang: string) {
    if (this.writesBlocked) { return; }
    const modalRef = this.modalService.open(EditQuestionComponent);
    modalRef.componentInstance.initParams(this.standard, question, lang);
    this.watchStandardModal(modalRef);
  }

  deleteQuestion(question: Question, lang: string): void {
    if (this.writesBlocked) { return; }
    const removedQuestion: Question = JSON.parse(JSON.stringify(question));
    this.writeAction.run(this.standard as Standard, snapshot => {
      const modal = this.modalService.open(ConfirmationPopupComponent);
      modal.componentInstance.massage = QUESTION_REMOVE_CONFIRM;
      return Observable.fromPromise<string>(modal.result).catch(() => Observable.of(CONFIRM_CANCELLED))
        .filter(result => result === CONFIRM_ACCEPTED)
        .concatMap(() => this.adminService.deleteQuestionFromStandard(snapshot, removedQuestion, lang));
    }, response => {
      if (response.status !== STANDARD_RESPONSE_OK) { this.writeAction.reject(); return; }
      const questions = lang === QUESTION_LANGUAGE_RUSSIAN ? this.standard.russianQuestions : this.standard.englishQuestions;
      const index = questions.indexOf(question);
      if (index >= FIRST_QUESTION_INDEX) { questions.splice(index, REMOVED_QUESTION_COUNT); }
      this.errorMessage = false;
    });
  }

  filterBy(prop: string, list: string) {
    if (list === 'initiators') {
      if (this.users !== undefined) {
        return this.users.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
      }
    }
    if (list === 'departments') {
      if (this.divisions !== undefined) {
        return this.divisions.sort((a, b) => a[prop].toLowerCase() > b[prop].toLowerCase() ? 1 : a[prop].toLowerCase() === b[prop].toLowerCase() ? 0 : -1);
      }
    }
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-standard/view-standard.component.ts